import cn from 'classnames';
import { FC, useMemo, useRef } from 'react';

import usePurchase from '~utils/hooks/usePurchase';

import { SeatArea, SeatRow } from '~types';

import Seat from '../Seats/Seat';
import { SeatsProps } from '../Seats/Seats';
import s from '../Seats/Seats.module.css';

const SeatsPreview: FC<Partial<SeatsProps>> = ({ data, roomType }) => {
  const { seats, reservedSeats } = usePurchase();
  const layoutRef = useRef<HTMLDivElement>(null);
  const selectedSeatsIds = seats.map((seat) => seat.id);
  const reservedSeatsIds = reservedSeats?.map((seat) => seat.id) || [];
  const gridColumns = useMemo(() => {
    if (!data) {
      return 0;
    }
    let maxRows = 0;
    let maxColumns = 0;
    data.areas.forEach((area) => {
      const rows = parseInt(area.areaLayoutRows, 10);
      const columns = parseInt(area.areaLayoutColumns, 10);

      maxRows = maxRows < rows ? rows : maxRows;
      maxColumns = maxColumns < columns ? columns : maxColumns;
    });

    return maxColumns;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const renderRow = (row: SeatRow) => {
    return (
      // @ts-ignore
      <div className={s.layoutRow} style={{ '--gridColumns': gridColumns }} key={row.rowPhysicalId}>
        {row.seats.map((seat) => {
          const seatKey = `${row.rowPhysicalId}${seat.seatNumber}`;
          const status = ((): '0' | '1' | '3' | '4' | '5' => {
            if (selectedSeatsIds.includes(seatKey)) return '5';
            if (reservedSeatsIds.includes(seatKey)) return '0';
            return seat.seatStatus as '1' | '3' | '4';
          })();

          const gridPosition = gridColumns - parseInt(seat.gridSeatNumber, 16) + 1;
          return (
            <Seat
              hideNumber
              key={seatKey}
              data={seat}
              status={status}
              gridPosition={gridPosition}
            />
          );
        })}
      </div>
    );
  };

  const renderArea = (area: SeatArea) => {
    const layoutRows = parseInt(area.areaLayoutRows, 10);
    const rows = [];

    for (let i = layoutRows; i >= 0; i--) {
      const row = area.rows[i];

      if (row && row.rowPhysicalId) {
        rows.push(renderRow(row));
      }
    }

    return rows;
  };
  const areas = data?.areas || [];
  return (
    <div ref={layoutRef} className={`${s.root} ${s.preview}`}>
      <div className={s.layoutBody}>
        <div>
          <div
            className={cn('mb-1 bg-gray-200 dark:bg-neutral-800 text-center text-xs', {
              [s.layoutMegaScreen]: roomType?.mega,
            })}
          >
            <span>{roomType?.mega ? 'Mega Pantalla' : 'Pantalla'}</span>
          </div>
          <div className={cn(s.layoutSeats)}>
            {areas.map((area: SeatArea) => {
              return renderArea(area);
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SeatsPreview;
